<div class="painel-principal" style="padding: 10px;">

        <mat-toolbar class="titulopartes">Dados Iniciais</mat-toolbar>

        <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
            <!-- #UNIDADE -->
            <mat-form-field fxFlex="30%" fxLayoutGap="20px" fxFlexOffset="20px">
                <mat-label>Unidade:</mat-label>
                <mat-select [(ngModel)]=movimentacoes.unidade.idUnidade name="unidade">
                    <mat-option></mat-option>
                    <mat-option *ngFor="let i of unidades" [value]=i.idUnidade>
                        {{i.nomeUnidade}}
                    </mat-option>
                </mat-select>
                <mat-hint *ngIf="unidades?.length === 0" align="start">Nenhuma unidade
                    cadastrada</mat-hint>
            </mat-form-field>
            
            <!-- #DEPARTAMENTO -->
            <mat-form-field fxFlex="30%" fxLayoutGap="20px" fxFlexOffset="20px">
                <mat-label>Departamento:</mat-label>
                <mat-select [(ngModel)]=movimentacoes.departamento.idDepartamento name="departamento">
                    <mat-option></mat-option>
                    <mat-option *ngFor="let i of departamentos" [value]=i.idDepartamento>
                        {{i.nmDepartamento}}
                    </mat-option>
                </mat-select>
                <mat-hint *ngIf="departamentos?.length === 0" align="start">Nenhum departamento
                    cadastrada</mat-hint>
            </mat-form-field>

          
            <!-- #TIPO MOVIMENTACAO -->
            <mat-form-field fxFlex="30%" fxLayoutGap="20px" fxFlexOffset="20px">
                <mat-label>Tipo Movimentação:</mat-label>
                <mat-select [(ngModel)]=movimentacoes.tipoMovimentacao name="tipoMovimentacao" required>
                    <mat-option></mat-option>
                    <mat-option *ngFor="let i of tiposMovimentacao.tipos" [value]=i.id>
                        {{i.descricao}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutGap="50px" style="padding-top: 20px;" fxFlexFill>

            <!-- #DESCRICAO MOVIMENTACAO  -->
            <mat-form-field fxFlexOffset="20px" fxFlex="95%" appearance="outline">
                <mat-label>Descrição:</mat-label>
                <textarea [(ngModel)]=movimentacoes.descricaoMovimentacaoMaterial matInput #message name="descricao" cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="3" maxlength="200">
                </textarea>
                <mat-hint align="end">{{message.value.length}} / 200</mat-hint>
            </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px; padding-bottom:20px" fxFlexFill>

            <div ngModelGroup="comboPrograma" fxFlex="30%" fxLayoutGap="20px" fxFlexOffset="20px">
                <mat-toolbar class="titulopartes">Programa</mat-toolbar>
                <combo-programa [showDisplayId]="false" 
                                [obrigatorio]="false" 
                                [selecionado]="filtro.programa"
                                (valorChange)="onValorChangePrograma($event)">
                </combo-programa>
            </div>

            <div ngModelGroup="comboProjeto" fxFlex="30%" fxLayoutGap="20px" fxFlexOffset="20px">
                <mat-toolbar class="titulopartes">Projeto</mat-toolbar>
                <combo-projeto [showDisplayId]="false" 
                               [obrigatorio]="false" 
                               [selecionado]="filtro.projeto"
                               (valorChange)="onValorChangeProjeto($event)">
                </combo-projeto>
            </div>

            <!-- #EMPRESA -->
            <div ngModelGroup="comboEmpresa" fxFlex="30%" fxLayoutGap="20px" fxFlexOffset="20px">
                <mat-toolbar class="titulopartes">Empresa</mat-toolbar>
                <mat-form-field fxFlex="30%" fxLayoutGap="20px" fxFlexOffset="20px">
                    <mat-select [(ngModel)]=movimentacoes.empresa.id name="empresa">
                        <mat-option></mat-option>
                        <mat-option *ngFor="let i of empresas" [value]=i.id>
                            {{i.nomeRazaoSocial}}
                        </mat-option>
                    </mat-select>
                    <mat-hint *ngIf="empresas?.length === 0" align="start">Nenhuma empresa cadastrada</mat-hint>
                </mat-form-field>
            </div>

        </div>

        <div fxLayout="row" fxFlexFill>
            <mat-form-field fxFlex="30%" fxFlexOffset="20px">
                <input [(ngModel)]=movimentacoes.numeroDocumento type="number" min=0 matInput  
                    name="numeroDocumento" placeholder="Número do documento:" />
            </mat-form-field>
        </div>
    

      
</div>